import React from 'react'
import { Link } from 'react-router-dom'

export default function GuestHeader() {
  return (
    <header className="border-b-[3px] border-ink bg-paper">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-3">
        <Link to="/" className="inline-flex items-center gap-2">
          <img src="/logo-mark.png" alt="" className="h-8 w-8 sm:h-9 sm:w-9" />
          <span className="text-lg sm:text-xl font-extrabold tracking-tight text-ink">MyWrenchLog</span>
        </Link>
      </div>
    </header>
  )
}
